import manifest from '../generated/images.json';
import { IMAGE_ALIASES } from '../config';

const isUrl = (s) => /^(https?:)?\/\//i.test(s);

/** Sheet image paths look like "img/izetrio/photo.jpg": serve them from /public. */
export const assetUrl = (src) =>
  isUrl(src) ? src : `${process.env.PUBLIC_URL || ''}/${src.replace(/^\/+/, '')}`;

const exact = new Set(manifest);
const lower = new Map(manifest.map((p) => [p.toLowerCase(), p]));
const byName = new Map();
manifest.forEach((p) => {
  const name = p.split('/').pop().toLowerCase();
  if (!byName.has(name)) byName.set(name, p);
});
const aliases = new Map(Object.entries(IMAGE_ALIASES).map(([k, v]) => [k.toLowerCase(), v]));
const warned = new Set();

/**
 * Finds the picture a sheet is asking for in public/img:
 *  1. the exact path, 2. the same path ignoring capitals, 3. a stand-in from
 *  IMAGE_ALIASES, 4. the same file name in another folder. Otherwise the path is
 *  used as written (the file may live on the server only).
 */
export function resolveImage(src) {
  if (!src || isUrl(src) || manifest.length === 0) return src;
  const clean = src.replace(/^\/+/, '');
  if (exact.has(clean)) return clean;
  if (lower.has(clean.toLowerCase())) return lower.get(clean.toLowerCase());

  let found = (aliases.get(clean.toLowerCase()) || []).find((a) => exact.has(a));
  if (!found) found = byName.get(clean.split('/').pop().toLowerCase());
  if (found) {
    if (process.env.NODE_ENV === 'development' && !warned.has(clean)) {
      warned.add(clean);
      console.warn(`[izetrio] "${clean}" (named in a sheet) is not in public/img. Showing "${found}" instead. Copy the real file to public/img to fix this.`);
    }
    return found;
  }
  if (process.env.NODE_ENV === 'development' && !warned.has(clean)) {
    warned.add(clean);
    console.warn(`[izetrio] "${clean}" (named in a sheet) is not in public/img.`);
  }
  return clean;
}
